
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_additional"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefit_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"display_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dm_brief"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"option_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan_ratio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dm_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"request_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"constant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value_type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_target"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"request_variables"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request_variable"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"range"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"variable_id"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount_options"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"range"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"option_id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"feetables"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feetable_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"axis_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"option_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan_ratio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axis_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"constant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value_type"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"benefit_restrict"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spouse_age_bound"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"children_age_bound"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parent_age_bound"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assumed_interest"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":705}};
    doc.loc.source = {"body":"fragment PlanFull on Plan {\n  _id\n  name\n  is_additional\n  benefits {\n    benefit_id\n    display_name\n    dm_brief\n    option_id\n    plan_ratio\n    dm_note\n    request_unit\n    constant\n    value_type\n  }\n  uploader\n  matched_state\n  matched_target\n  request_variables {\n    request_variable {\n      request_type\n      range\n      list\n      variable_id\n    }\n  }\n  amount_options {\n    name\n    type\n    range\n    list\n    unit\n    option_id\n  }\n  feetables {\n    feetable_id\n    axes {\n      axis_id\n      option_id\n      plan_ratio\n      axis_value\n      constant\n      value_type\n    }\n  }\n  ticket_id\n  benefit_restrict\n  spouse_age_bound\n  children_age_bound\n  parent_age_bound\n  assumed_interest\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PlanFull"] = oneQuery(doc, "PlanFull");
        
